import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTradingViewLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTradingViewLine"><Path fillRule="evenodd" clipRule="evenodd" d="M22.78 7.62463L14.099 18.476L7.05435 11.7668L2.74245 16.5578L1.25586 15.2199L6.94396 8.89975L13.8993 15.5239L21.2183 6.37524L22.78 7.62463Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTradingViewLine;
